import 'css-chunksrc/feature/flip-and-tip/FlipAndTipForm.module.scss';export default {
  "root": "FlipAndTipForm_root",
  "content": "FlipAndTipForm_content",
  "tip_group": "FlipAndTipForm_tip_group",
  "tip_custom": "FlipAndTipForm_tip_custom",
  "submit_cta": "FlipAndTipForm_submit_cta",
  "visible": "FlipAndTipForm_visible"
};